export const HOURS_BUDGE_SIZE = 18;
